import { withViewModel } from '../../../../../../../infrastructure/components/with-view-model';
import { EmailTemplatesFormPresentation } from './email-templates-form-presentation';
import { EmailsTemplateFormVM } from '../emails-template-form.viewmodel';

interface IProps {
    vm: EmailsTemplateFormVM;
}

const EmailTemplatesFormContainer = withViewModel(
    EmailTemplatesFormPresentation,
    (props: IProps) => {
        props.vm.fetchEmailLogoData();
        return props.vm;
    },
    () => []
);

export { EmailTemplatesFormContainer as EmailTemplatesForm };
